/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    p: "p",
    ol: "ol",
    li: "li",
    h3: "h3",
    a: "a",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Principles & Values"
    }), "\n", _jsx(_components.h2, {
      children: "Purpose"
    }), "\n", _jsx(_components.p, {
      children: "The purposes of Eufemia are:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "To establish a shared vocabulary and an open platform for designers and developers."
      }), "\n", _jsx(_components.li, {
        children: "To ensure consistency and adherence to the look and feel of DNB digital products."
      }), "\n", _jsx(_components.li, {
        children: "To provide principles and guidelines for designers and developers."
      }), "\n", _jsx(_components.li, {
        children: "To encourage re-use of code and design resources."
      }), "\n", _jsx(_components.li, {
        children: "To exist as a single source of truth."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Introduction"
    }), "\n", _jsx(_components.p, {
      children: "You will find two sets of principles in the DNB Design System and one set of values."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Design System principles: this is a set of principles for users of the Design System."
      }), "\n", _jsx(_components.li, {
        children: "End-user principles - the principles upon which we build DNB products and services for our users."
      }), "\n", _jsx(_components.li, {
        children: "Brand values - located in the Brand book."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Design System Principles (Eufemia Principles)"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Don't add bloat to the system at the same time do not let the system develop debt - old content is no longer relevant."
      }), "\n", _jsx(_components.li, {
        children: "The system and its content should be self-explanatory - easily picked up and understood by a new designer or developer, i.e not dependent on a single individual."
      }), "\n", _jsx(_components.li, {
        children: "Add content to the system like it's your last day - add comments, clear succinct descriptions to code and design files."
      }), "\n", _jsx(_components.li, {
        children: "Eliminate this question: \"I'm new here - where do I find the...\"."
      }), "\n", _jsx(_components.li, {
        children: "The work is never done - A system of guides can and should be continuously improved."
      }), "\n", _jsx(_components.li, {
        children: "Focus more on communication than the tools of the trade - common language and understanding, frequent discussions, including of all stakeholders..."
      }), "\n", _jsx(_components.li, {
        children: "Stay agnostic - code, data, and design file formats should remain as platform and application-independent as possible."
      }), "\n", _jsxs(_components.li, {
        children: ["Comply to the ", _jsx(_components.a, {
          href: "/uilib/getting-started/living-system",
          children: "living system"
        }), " principles as well as the ", _jsx(_components.a, {
          href: "/uilib/getting-started/maintainability",
          children: "maintainability"
        }), " principles."]
      }), "\n", _jsx(_components.li, {
        children: "Test Test Test - continually test the system with its users to ensure it is relevant, usable, and goal."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "End-user Principles"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Design for all - follow accessibility and usability guidelines for everything you make."
      }), "\n", _jsx(_components.li, {
        children: "Start with users - gain insight, discover their needs, understand them."
      }), "\n", _jsx(_components.li, {
        children: "Understand context - when, how, where, with which device, etc."
      }), "\n", _jsx(_components.li, {
        children: "Maintain consistency both visually and through the re-application of design extensions."
      }), "\n", _jsx(_components.li, {
        children: "Just enough interface. When in doubt, remove."
      }), "\n", _jsx(_components.li, {
        children: "Design and code with performance highly prioritized."
      }), "\n", _jsx(_components.li, {
        children: "Consistent experience across all platforms - small touch screens to large desktop displays."
      }), "\n", _jsx(_components.li, {
        children: "Reuse, reduce and recycle. Harness the efficiency of reusing extensions and components."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "DNB Brand values"
    }), "\n", _jsx(_components.p, {
      children: "DNB Brand values are located on page 6 of the DNB Brand book. The values are built on these three foundations:"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "Curiosity"
      }), ", ", _jsx(_components.strong, {
        children: "Responsibility"
      }), ", ", _jsx(_components.strong, {
        children: "Bravery"
      })]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
